import { formatMoney, getSizedImageUrl } from '//www.liquid-life.de/cdn/shop/t/94/assets/theme.js?v=27372344513999645111746606423';

var AlgoliaDrawerSearch = class extends HTMLElement {
  constructor() {
    super();

    this.els = this.getEls();
  }

  connectedCallback() {
    this.appendCurrentSearches();
    this.els.updateQueryButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const query = e.currentTarget.dataset.updateQuery;
        this.updateSearchQuery(query);
      });
    });

    const observerInput = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          this.els = this.getEls();
          const aaInput = document.querySelector('.aa-Input');
          if (this.els.searchInput) {
            this.setupInputListener();
            observerInput.disconnect();
          }
        }
      }
    });

    observerInput.observe(document.body, { childList: true, subtree: true });

    const observedElement = document.querySelector('#search-drawer');
    const observerSearchDrawer = new MutationObserver((mutationsList, observer) => {
      for(const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('search-drawer--visible')) {
            this.onSearchDrawerClassChange();
          }

        }
      }
    });

    const config = { attributes: true };
    observerSearchDrawer.observe(observedElement, config);
  }

  onSearchDrawerClassChange() {
    this.els = this.getEls();

    if(this.els.searchInputHeader.value != '') {
      this.updateSearchQuery(this.els.searchInputHeader.value)
    }
  }

  setupInputListener() {
    this.els = this.getEls();

    this.els.searchInput.addEventListener('blur', event => {
      this.updateRecentSearches(event.target.value);
    });
  }

  /**
   * Updates the value of the search query
   */
  updateSearchQuery(query) {
    this.els = this.getEls();

    this.els.searchInput.value = query;
    this.els.searchInput.dispatchEvent(new Event('input'));
  }

  /**
   * Adds currently searches queries to the header
   */
  appendCurrentSearches() {
    this.els = this.getEls();

    let items = this.getRecentSearches().reverse().slice(0,5);

    if (items.length > 0) {
      this.els.recentSearches.innerHTML =
        items.map(item => `
          <button type="button" class="button button--xs-sm ll_button_outline buy-buttons--square" is="custom-button" data-update-query>${item}</button>
        `).join('');
      
      this.els.recentSearchesContainer.removeAttribute('hidden');

      this.els.recentSearches.addEventListener('click', (event) => {
        if (event.target.closest('[data-update-query]')) {
          this.updateSearchQuery(event.target.innerText);
        }
      });
    }
  }

  /**
   * Updates recent searches made in localStorage array
   */
  updateRecentSearches(query) {
    let items = this.getRecentSearches();
    
    if (query !== '') {
      items = items.filter(item => item.toLowerCase() !== query.toLowerCase());
      items.push(query);
      localStorage.setItem('theme::recent-searches', JSON.stringify(items));
    }
  }

  /**
   * Gets recent search queries from localStorage
   */
  getRecentSearches() {
    return JSON.parse(localStorage.getItem('theme::recent-searches') || "[]");
  }

  getEls () {
    return {
      searchInputHeader: document.querySelector('.header__mobile-search .search-input-field input'),
      searchInput: document.querySelector('.aa-Input'),
      startupContainer: document.querySelector('[data-startup-container]'),
      updateQueryButtons: [...document.querySelectorAll('[data-update-query]')],
      recentSearches: document.querySelector('[data-recent-searches]'),
      recentSearchesContainer: document.querySelector('[data-recent-searches-container]'),
    }
  }
}

if (!customElements.get('algolia-drawer-search')) {
  customElements.define('algolia-drawer-search', AlgoliaDrawerSearch);
}